var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_104_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 30,
    height: 30,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_104_12",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_104_12",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_104_12",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cd5aae8480f1d3a61ab908053db80e93.svg";
export { ForwardRef as ReactComponent };